/**
 * Global full-page loading overlay — blocks clicks on the page while a form submits
 * or while you hold the lock for async work.
 *
 * Automatic: on <form> submit, the spinner panel is centered in the viewport.
 * Show is deferred with setTimeout(0) so bubble-phase handlers can call preventDefault()
 * (e.g. SweetAlert delete confirm); if they do, we never show the overlay.
 *
 * Manual: window.GlobalPageLoading.show() / .hide() / .forceHide()
 *
 * Opt out: <form data-no-global-loading> or data-global-loading="false"
 */
(function () {
    'use strict';

    const HIDDEN = 'global-page-loading--hidden';
    const BODY_ACTIVE = 'global-page-loading-active';

    function getOverlay() {
        return document.getElementById('global-page-loading');
    }

    function setOverlayVisible(visible) {
        const el = getOverlay();
        if (!el) return;

        if (visible) {
            el.removeAttribute('hidden');
            el.classList.remove(HIDDEN);
            el.setAttribute('aria-hidden', 'false');
            el.setAttribute('aria-busy', 'true');
            document.body.classList.add(BODY_ACTIVE);
        } else {
            el.setAttribute('hidden', '');
            el.classList.add(HIDDEN);
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('aria-busy', 'false');
            document.body.classList.remove(BODY_ACTIVE);
        }
    }

    let lockCount = 0;

    window.GlobalPageLoading = {
        /**
         * @param {HTMLElement} [_anchorEl] — ignored; kept for API compatibility.
         */
        show: function (_anchorEl) {
            lockCount += 1;
            if (lockCount === 1) {
                setOverlayVisible(true);
            }
        },

        hide: function () {
            lockCount = Math.max(0, lockCount - 1);
            if (lockCount === 0) {
                setOverlayVisible(false);
            }
        },

        forceHide: function () {
            lockCount = 0;
            setOverlayVisible(false);
        },

        isShowing: function () {
            return lockCount > 0;
        }
    };

    function shouldSkipForm(form) {
        if (!form || form.tagName !== 'FORM') return true;
        if (form.hasAttribute('data-no-global-loading')) return true;
        const attr = form.getAttribute('data-global-loading');
        if (attr === 'false' || attr === '0') return true;
        return false;
    }

    document.addEventListener(
        'submit',
        function (e) {
            const form = e.target;
            if (!(form instanceof HTMLFormElement)) return;
            if (shouldSkipForm(form)) return;
            const submitEvent = e;
            window.setTimeout(function () {
                if (submitEvent.defaultPrevented) {
                    return;
                }
                window.GlobalPageLoading.show();
            }, 0);
        },
        true
    );
})();
